import { isPcApp, isiOS } from "./runTimeEnv";

/**
* 比较版本号的大小，如果curV 大于等于 reqV，则返回true，否则返回false
* @param {String} curV
* @param {String} reqV
*/
export const Version = (reqV: any, curV: any) => {
    if (!curV && isPcApp()) {
        _getAppVer().then(res => {
            curV = res;
        })
    }
    // 参数相等
    if (curV === reqV) return true
    const arr1 = curV.toString().split('.');
    const arr2 = reqV.toString().split('.');
    // 将两个版本号拆成数字
    const minL = Math.min(arr1.length, arr2.length);
    let pos = 0; // 当前比较位
    let diff = 0; // 当前为位比较是否相等
    let flag = false;
    // 逐个比较如果当前位相等则继续比较下一位
    while (pos < minL) {
        diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
        if (diff === 0) {
            pos++;
            continue;
        } else if (diff > 0) {
            flag = true;
            break;
        } else {
            flag = false;
            break;
        }
    }
    return flag;
}

function _getAppVer() {
    return new Promise(resolve => {
        if (isiOS() && window?.webkit?.messageHandlers?.PCJSKit) {
            window.webkit.messageHandlers.PCJSKit.postMessage({
                functionName: 'appVer',
            })
        } else if (window?.PCJSKit?.appVer) {
            resolve(window.PCJSKit.appVer())
        } else {
            resolve('')
        }
    })
}